module.exports = __webpack_public_path__ + "2993fdf7e01a4df80879ff44e3bda992.pdf";